<template>
  <v-row no-gutters>
    <v-col cols="12" class="d-flex flex-column gap-8">
      <gate-feed-page-header />
      <gate-feed-page-table :observations="observations" />
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent } from 'vue';
import { onBeforeMount } from 'vue';

import useGateFeed from './composables/useGateFeed';
import GateFeedPageHeader from './components/GateFeedPageHeader.vue';
import GateFeedPageTable from './components/GateFeedPageTable.vue';

export default defineComponent({
  name: 'GateFeedPage',
  components: { GateFeedPageHeader, GateFeedPageTable },
  props: {},
  setup() {
    const gateFeedStore = useGateFeed();

    const observations = gateFeedStore.observationsRef;

    onBeforeMount(() => {
      gateFeedStore.trackMixpanelEvent(gateFeedStore.MixPanelEvent.VIEW_PAGE, {
        metadata: {
          page: 'Gate Feed'
        }
      });
    });

    return { enableGateFeedPage: gateFeedStore.enableGateFeedPageRef.value, observations };
  },
  beforeMount() {
    // TODO: Remove this when the ff enable-gate-feed-page-helios is removed
    // Redirect to appointments page if gate feed page is disabled
    if (!this.enableGateFeedPage) {
      this.$router.replace({ name: 'appointments' });
    }
  }
});
</script>
